export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-dollar-bill-35b8562b708268b7cf19dba262fa51f9.svg";